import { Collapse } from 'antd';

import type { NClientsList } from '@pages/Clients/ClientsList/ClientsList.types';

export const AdaptedFilter: NClientsList.AdaptedFilter = ({
  filterElements,
}) => {
  return (
    <Collapse
      className="chf-collapse"
      accordion
      ghost
      bordered={false}
      items={filterElements.map((item, index) => {
        const isLastItem = index === filterElements.length - 1;

        if (isLastItem) {
          return {
            ...item,
            children: item?.children?.[0].label || <></>,
            showArrow: false,
          };
        } else {
          return {
            ...item,
            children: item?.children?.[0].label || <></>,
          };
        }
      })}
    />
  );
};
